import { render } from "./DonationCarousel.vue?vue&type=template&id=3ebf591e&scoped=true"
import script from "./DonationCarousel.vue?vue&type=script&lang=js"
export * from "./DonationCarousel.vue?vue&type=script&lang=js"

import "./DonationCarousel.vue?vue&type=style&index=0&id=3ebf591e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebf591e"]])

export default __exports__